import { getValueOrReturnValue, MaybeGetter } from "@/types/maybe-getter";
import { useCallback, useMemo, useRef, useState } from "react";

export function useStateWithGetter<T>(initialValue: MaybeGetter<T>) {
  const ref = useRef(getValueOrReturnValue(initialValue));
  const [state, setState] = useState(ref.current);

  const getValue = useCallback(() => ref.current, []);
  const setValue = useCallback((valueOrGetter: T | ((prev: T) => T)) => {
    let value: T;
    if (typeof valueOrGetter === "function") {
      value = (valueOrGetter as (prev: T) => T)(ref.current);
    } else {
      value = valueOrGetter;
    }

    ref.current = value;
    setState(value);
  }, []);

  return useMemo(
    () => [state, getValue, setValue] as const,
    [state, getValue, setValue],
  );
}
